<informational-message (showInfo)="onShowInfo()" iconPosition="LEFT">{{
  'results_sorting' | translate
}}</informational-message>
